import { render } from "./App.vue?vue&type=template&id=cb9888f2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=cb9888f2&lang=css"
script.render = render

export default script